const scrollTimelineSupport = CSS.supports("animation-timeline: --works")
    ? Promise.resolve()
    : import("./scroll-timeline")

async function setupNavigationLogoAnimation() {
    await scrollTimelineSupport

    const logo = document.querySelector(".c-main-navigation__logo")
    if (!logo) return

    const timeline = new ScrollTimeline({ source: document.scrollingElement, axis: "block" })
    const rangeOptions = { rangeStart: "0px", rangeEnd: "50px", fill: "forwards", duration: 1 }

    logo.animate([{ transform: "scale(1)" }, { transform: "scale(0.617)" }], { ...rangeOptions, timeline })
    logo.querySelector(".logo-text")?.animate([{ opacity: 1 }, { opacity: 0 }], { ...rangeOptions, timeline })
}

setupNavigationLogoAnimation()

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
            setTimeout(() => {
                entry.target.classList.add("intersected")
            }, 250)
        }
    })
})

const observeElements = () => {
    [...document.querySelectorAll(".intersect-start")].forEach((element) => {
        observer.observe(element)
    })
}

// Initial observation
observeElements()

// Observe future DOM changes
const mutationObserver = new MutationObserver(() => {
    observeElements()
})

mutationObserver.observe(document.body, { childList: true, subtree: true })
;[...document.querySelectorAll(".intersect-start")].forEach((element) => {
    observer.observe(element)
})
